var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_vm._v("\n  Show current News Elements here\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }